import {
  ITrackablePartnerStoreCardClickedAction,
  ITrackablePartnerStoreCardViewedAction,
} from '../../interfaces/partners'
import {
  PARTNER_STORE_CARD_CLICKED,
  PARTNER_STORE_CARD_VIEWED,
} from '../../constants/trackableActions'

export const trackPartnerStoreCardClicked = ({
  card_style = null,
  cards_quantity = null,
  position = null,
  screen_name = null,
  store_id = null,
  vendorId = null,
  referrer = null,
  module_name = null,
  value_stream = 'HOMEPAGE',
}): ITrackablePartnerStoreCardClickedAction => ({
  type: PARTNER_STORE_CARD_CLICKED,
  payload: {
    card_style,
    cards_quantity,
    module_name,
    position,
    screen_name,
    store_id,
    vendorId,
    referrer,
    value_stream,
  },
})

export const trackPartnerStoreCardViewed = ({
  card_style = null,
  cards_quantity = null,
  position = null,
  screen_name = null,
  store_id = null,
  vendorId = null,
  referrer = null,
  module_name = null,
  value_stream = 'HOMEPAGE',
}): ITrackablePartnerStoreCardViewedAction => ({
  type: PARTNER_STORE_CARD_VIEWED,
  payload: {
    card_style,
    cards_quantity,
    position,
    screen_name,
    module_name,
    store_id,
    vendorId,
    referrer,
    value_stream,
  },
})
